import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import './NoProductsFound.css'
import { useTranslation } from "react-i18next";

const NoProductsFound = () => {
  const { t } = useTranslation();
  return (
    <div className="no-products-container">
      <div className="no-products-content">
        <FontAwesomeIcon icon={faSearch} className="no-products-icon" />
        <h3 className="no-products-title">{t("No_Products_Found")}</h3>
        <p className="no-products-message">
          {t("Sorry,_we_couldn't_find_any_products_matching_your_search_criteria.")}
        </p>
        {/* <button className="back-to-home-btn">Back to Home</button> */}
      </div>
    </div>
  );
};

export default NoProductsFound;
